import { render, staticRenderFns } from "./AppModalMostrarDocumentosPDF.vue?vue&type=template&id=4b8f2a36&scoped=true"
import script from "./AppModalMostrarDocumentosPDF.vue?vue&type=script&lang=js"
export * from "./AppModalMostrarDocumentosPDF.vue?vue&type=script&lang=js"
import style0 from "./AppModalMostrarDocumentosPDF.vue?vue&type=style&index=0&id=4b8f2a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f2a36",
  null
  
)

export default component.exports